<template>
	<n-tooltip class="text-fs-xs! px-1.5! py-1!">
		<template #trigger>
			<n-tag :round :color="{ color: 'transparent' }" :size class="text-fs-sm font-normal">
				<template v-if="icon" #icon>
					<Icon :name="icon" :size="sizePX" />
				</template>
				{{ label }}
			</n-tag>
		</template>
		{{ $t(`patients.tags.current_mother_weight`) }}
	</n-tooltip>
</template>

<script setup lang="ts">
import type { I18nString } from "@/lang/config"
import type { PatientMeta } from "@/types/patient"
import { NTag, NTooltip } from "naive-ui"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"

const { meta, size } = defineProps<{
	meta: PatientMeta
	round?: boolean
	size?: "small" | "medium" | "large" | "tiny"
}>()

const { t } = useI18n()

const sizePX = computed(() => (size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : 14))

const label = computed(() => {
	if (meta.start_weight && meta.last_weight) {
		return `${meta.last_weight} kg (${(meta.delta_weight || 0) >= 0 ? "+" : ""}${meta.delta_weight} kg)`
	}
	return t<I18nString>(`patients.tags.weight_not_recorded`)
})

const icon = computed(() => ICONS.mother_weight)
</script>
